import React from "react";
import SuccessIcon from "../SuccessIcon/SuccessIcon";
import "./Success.css";

const Success = (props) => {
  return (
    <>
      <SuccessIcon />
      <h2 className="headline-4">Password updated!</h2>
    </>
  );
};

export default Success;
